import { useQuery } from "@tanstack/react-query";

import { customFetch } from "../util/customFetch";

export function useCategories({ enabled = true, params }) {
  const page = params?.page || params?.firstResult;
  const size = params?.size || params?.pageSize;
  const sortOrder = params?.sortOrder || "desc";
  const sort = params?.sortBy
    ? `${params?.sortBy},${sortOrder}`
    : params?.sort
      ? `${params?.sort},${sortOrder}`
      : "";

  const queryParams = { page, size, sortOrder, sort };

  return useQuery({
    enabled,
    queryKey: ["categories"],
    queryFn: async () =>
      customFetch(
        `/api/smartbpm/v1/{tenant}/categories?${new URLSearchParams(queryParams)}`,
      ),
  });
}
